import { ApiClient } from './apiClient';
import { OrderService } from './services/orderService';
import { PricingService } from './services/pricingService';
import { NewsletterService } from './services/newsLetterService';
import { CardService } from './services/cardService';
import { CartService } from './services/cartService';
import { ContactService } from './services/contactService';
import { BlogService } from './services/blogService';
import { ReviewService } from './services/reviewService';
import { BrandFamilyService } from './services/brandFamilyService';
import { CustomPageService } from './services/customPageService';
import { AuthService } from './services/authService';
import { WishlistService } from './services/wishlistService';
import { BalanceService } from './services/balanceService';
import { CashbackService } from './services/cashbackService';
import { ReferralService } from './services/referralService';
import { BannerService } from './services/bannerService';
import { VerificationService } from './services/verificationService';
import { BankAccountsService } from './services/bankAccountsService';
import { KycService } from './services/kycService';
import { AssistantService } from './services/assistantService';

/**
 * Gateway Client - main API client that combines all services
 */
export class GatewayClient {
  public apiClient: ApiClient;

  // Service instances
  public cards: CardService;
  public cart: CartService;
  public orders: OrderService;
  public pricing: PricingService;
  public newsletter: NewsletterService;
  public contact: ContactService;
  public blog: BlogService;
  public reviews: ReviewService;
  public brandFamilies: BrandFamilyService;
  public customPages: CustomPageService;
  public auth: AuthService;
  public wishlist: WishlistService;
  public balance: BalanceService;
  public cashback: CashbackService;
  public referrals: ReferralService;
  public banners: BannerService;
  public verification: VerificationService;
  public bankAccounts: BankAccountsService;
  public kyc: KycService;
  public assistant: AssistantService;

  constructor(additionalHeaders?: Record<string, string>) {
    // Create the base API client
    this.apiClient = new ApiClient(additionalHeaders);

    // Initialize all services
    this.cards = new CardService(this.apiClient);
    this.cart = new CartService(this.apiClient);
    this.orders = new OrderService(this.apiClient);
    this.pricing = new PricingService(this.apiClient);
    this.newsletter = new NewsletterService(this.apiClient);
    this.contact = new ContactService(this.apiClient);
    this.blog = new BlogService(this.apiClient);
    this.reviews = new ReviewService(this.apiClient);
    this.brandFamilies = new BrandFamilyService(this.apiClient);
    this.customPages = new CustomPageService(this.apiClient);
    this.auth = new AuthService(this.apiClient);
    this.wishlist = new WishlistService(this.apiClient);
    this.balance = new BalanceService(this.apiClient);
    this.cashback = new CashbackService(this.apiClient);
    this.referrals = new ReferralService(this.apiClient);
    this.banners = new BannerService(this.apiClient);
    this.verification = new VerificationService(this.apiClient);
    this.bankAccounts = new BankAccountsService(this.apiClient);
    this.kyc = new KycService(this.apiClient);
    this.assistant = new AssistantService(this.apiClient);
  }
}

// Export a singleton instance
export const gatewayClient = new GatewayClient();

// Re-export error types
export * from './errors';
export * from './apiClient';

// Re-export blog types
export * from '../types/blog';

// Re-export coupon types
export * from '../types/coupon';

// Re-export pagination types
export * from '../types/pagination';